.modal {
  min-width: 400px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  justify-content: space-between;
}
